var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 59.5001L129.1 132.6C128.998 133.803 128.427 134.918 127.51 135.704C126.593 136.489 125.404 136.883 124.2 136.8L59.0999 131.1C57.8961 130.974 56.7907 130.378 56.0232 129.442C55.2557 128.506 54.8881 127.305 54.9999 126.1L62.3999 41.5001C62.4367 40.9033 62.5947 40.3203 62.8643 39.7866C63.1339 39.2529 63.5095 38.7798 63.968 38.3961C64.4266 38.0124 64.9585 37.7262 65.5314 37.5549C66.1043 37.3837 66.706 37.331 67.2999 37.4001L121.6 42.1001L135.5 59.5001Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9999 29.2L71.3999 30.7L69.8999 13.2L88.9999 29.2Z",
    fill: "#DB6C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9999 29.2L71.3999 30.7L69.8999 13.2L88.9999 29.2Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6 29.3999L87 34.5999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138 59.7999L120.4 58.2L121.9 40.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1 68L120.3 72.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2999 77.5999L119.5 81.5999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 87L98.6 89.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8999 105.2L117.1 109.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70 114.7L115.9 118.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110.8L23.8 113.1C23.1954 113.155 22.586 113.089 22.0069 112.908C21.4277 112.726 20.8902 112.431 20.4255 112.041C19.9607 111.651 19.5777 111.172 19.2988 110.633C19.0198 110.094 18.8503 109.505 18.8 108.9L11.4 24.2999C11.3453 23.7006 11.4114 23.0965 11.5942 22.5233C11.7771 21.9501 12.0731 21.4193 12.4647 20.9625C12.8563 20.5056 13.3355 20.132 13.874 19.8636C14.4125 19.5952 14.9994 19.4375 15.6 19.3999L69.8 14.5999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2999 48.3L55.6999 45.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1 57.8L55.1 55.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8999 67.2999L54.2999 65.0999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 85.4999L52.2 83.5999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3999 95L51.7999 93.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesText);
export default __webpack_public_path__ + "static/media/pages_text.a63b01f6e4a33465460ceb3860794b15.svg";
export { ForwardRef as ReactComponent };